import { get } from 'lodash';
import { AxiosError, AxiosResponse } from 'axios';
import { camelize } from 'utils/camelize';

// constants
import { ERROR_TYPES, ERROR_CODE_PER_TYPE } from './event-manager-error.constants';

interface IServerError {
    Error: boolean;
    ErrorCode: number;
    ErrorMessage: string;
    ErrorDescription: string;
}

interface ICamelizedServerError {
    error: boolean;
    errorCode: number;
    errorMessage: string;
    errorDescription: string;
}

export default class EventManagerError {
    public type: string | null = null;

    constructor(type: string = ERROR_TYPES.SOMETHING_WRONG) {
        this.type = type;
    }

    public static fromAxiosError(error: AxiosError): EventManagerError {
        try {
            const method = this.extractMethodFromAxiosError(error);
            const errorCode = this.getErrorCodeFromAxiosError(error);

            const errorDescriptor = this.buildErrorDescriptor(errorCode, method);
            const type = this.determineTypeOfError(errorDescriptor);

            return new EventManagerError(type);
        } catch (e) {
            return new EventManagerError();
        }
    }

    private static getErrorCodeFromAxiosError(error: AxiosError): number {
        const responseError = (error.response as AxiosResponse<IServerError>).data;
        const camelResponse = <ICamelizedServerError> camelize(responseError);

        return get(camelResponse, 'errorCode');
    }

    private static extractMethodFromAxiosError(error: AxiosError): string {
        return error.config.method!.toUpperCase();
    }

    private static buildErrorDescriptor(code: number, method: string) {
        return `${method}:${code}`;
    }

    private static determineTypeOfError(descriptor: string): string {
        return ERROR_CODE_PER_TYPE[descriptor];
    }
}
